module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p'), _vm._v(" "), _c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments "), _c('span', {
    staticClass: "right"
  }, [_vm._v("vii")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_FM1"
    }
  }, [_vm._v("A Note on the Photographers "), _c('span', {
    staticClass: "right"
  }, [_vm._v("ix")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction "), _c('span', {
    staticClass: "right"
  }, [_vm._v("xiii")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1"
    }
  }, [_vm._v("I      What Got into His Head: Bernard Stollman, 1 Founder of the Label "), _c('span', {
    staticClass: "right"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN THE GREAT BEFORE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch1_1"
    }
  }, [_vm._v("1. Who, Where, When: Beginnings and Departures "), _c('span', {
    staticClass: "right"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch2"
    }
  }, [_vm._v("2. Music and Law: Into the Deep End Fast "), _c('span', {
    staticClass: "right"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch3"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE RISE AND FALL AND PERSISTENT RESURRECTION OF A CURIOUS RECORD COMPANY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch3_1"
    }
  }, [_vm._v("3. The Initial Years "), _c('span', {
    staticClass: "right"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch4"
    }
  }, [_vm._v("4. While It Worked "), _c('span', {
    staticClass: "right"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch5"
    }
  }, [_vm._v("5. Decline and Fall "), _c('span', {
    staticClass: "right"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch6"
    }
  }, [_vm._v("6. On Individual Artists "), _c('span', {
    staticClass: "right"
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch7"
    }
  }, [_vm._v("7. About Some Records "), _c('span', {
    staticClass: "right"
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch8"
    }
  }, [_vm._v("8. A Word or Two on Recording Engineers "), _c('span', {
    staticClass: "right"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch9"
    }
  }, [_vm._v("9. Close Encounters in the Music Business "), _c('span', {
    staticClass: "right"
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch10"
    }
  }, [_vm._v("10. A Short History of Licensing "), _c('span', {
    staticClass: "right"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch11"
    }
  }, [_vm._v("11. In the Wilderness "), _c('span', {
    staticClass: "right"
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1#ch12"
    }
  }, [_vm._v("12. Revival "), _c('span', {
    staticClass: "right"
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II    ESP-Disk’ as Lived and Witnessed "), _c('span', {
    staticClass: "right"
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ishmael Reed 85")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunter Hampel 87")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Tchicai 91")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Thornton 94")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Zitro 98")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sonny Simmons 103")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gary Peacock 109")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milford Graves 110")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alan Sondheim 119")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Rapp 126")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warren Smith 134")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roscoe Mitchell 140")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michael Snow 141")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part2#ch1_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marion Brown 145")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard Alderson 150")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roswell Rudd 160")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Montego Joe 166")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evan Parker 171")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alan Silva 172")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giuseppi Logan 180")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Stampfel 185")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burton Greene 192")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Coach with the Six Insides")]), _vm._v(": Jean Erdman and Van Dexter 199")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leo Feigin 204")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Erica Pomerance 205")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joe Morris 210")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Parker 217")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ken Vandermark 220")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gato Barbieri 224")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amiri Baraka 228")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michael D. Anderson 232")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sal Salgado 240")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lindha Kallerdahl 247")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sirone 248")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunny Murray 254")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marc Albert-Levin 260")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jacques Coursil 265")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steve Weber 273")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2a#ch1_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steve Stollman 279")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index "), _c('span', {
    staticClass: "right"
  }, [_vm._v("285")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa"
  }, [_c('i', [_vm._v("Photographs follow pages 77 and 184")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a86765","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 72
// module chunks = 0